import React from 'react';
import { Crown, Clock } from 'lucide-react';
import { useSubscription } from '../context/SubscriptionContext';
import { useLanguage } from '../context/LanguageContext';
import { Badge } from './ui/badge';

const SubscriptionBadge = () => {
  const { isPremium, isTrialing, trialDaysLeft, loading } = useSubscription();
  const { t } = useLanguage();

  if (loading) return null;

  if (isTrialing) {
    return (
      <Badge className="bg-gold/20 text-gold border-gold/30 hover:bg-gold/30">
        <Clock className="w-3 h-3 mr-1" />
        {trialDaysLeft}d {t('badge.trial')}
      </Badge>
    );
  }

  if (isPremium) {
    return (
      <Badge className="bg-gold/20 text-gold border-gold/30 hover:bg-gold/30">
        <Crown className="w-3 h-3 mr-1" />
        {t('badge.premium')}
      </Badge>
    );
  }

  return (
    <Badge variant="outline" className="text-muted-foreground">
      {t('badge.free')}
    </Badge>
  );
};

export default SubscriptionBadge;
